import Custom from './Custom.container';

export default Custom;
